import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  CompanyInfoLoaded,
  SelectBranch,
  SelectPlace,
  SetFailureOverlay,
  SetItemScrolledToBottom,
  SetLanguage,
  SetNotificationOverlay,
  SetSpinner,
} from './ui.actions';
import { ItemPlace } from '../../schema/item';

export interface UIStateModel {
  showSpinner: boolean;
  showFailureOverlay: boolean;
  showNotificationOverlay: boolean;
  notificationType: 'success' | 'error' | 'info' | 'warning';
  message: string;
  itemsScrolledToBottom: boolean;
  language: string;
  selectedBranch: {
    id: number;
    name: string;
    taxRate: number;
  } | null;
  selectedPlace: ItemPlace | null;
  companyInfoLoaded: boolean;
}

@Injectable()
@State<UIStateModel>({
  name: 'ui',
  defaults: {
    showSpinner: false,
    showFailureOverlay: false,
    showNotificationOverlay: false,
    notificationType: 'success',
    message: '',
    itemsScrolledToBottom: false,
    language: 'en',
    selectedBranch: null,
    selectedPlace: null,
    companyInfoLoaded: false,
  },
})
export class UIState {
  constructor() {}

  @Selector()
  static showSpinner(state: UIStateModel) {
    return state.showSpinner;
  }

  @Selector()
  static showNotificationOverlay(state: UIStateModel) {
    return state.showNotificationOverlay;
  }

  @Selector()
  static notificationType(state: UIStateModel) {
    return state.notificationType;
  }

  @Selector()
  static message(state: UIStateModel) {
    return state.message;
  }

  @Selector()
  static language(state: UIStateModel) {
    return state.language;
  }

  @Selector()
  static selectedBranch(state: UIStateModel) {
    return state.selectedBranch;
  }

  @Selector()
  static selectedPlace(state: UIStateModel) {
    return state.selectedPlace;
  }
  @Selector()
  static companyInfoLoaded(state: UIStateModel) {
    return state.companyInfoLoaded;
  }

  @Selector()
  static itemsScrolledToBottom(state: UIStateModel) {
    return state.itemsScrolledToBottom;
  }

  @Action(SetSpinner)
  setSpinner(ctx: StateContext<UIStateModel>, action: SetSpinner) {
    ctx.patchState({
      showSpinner: action.payload,
    });
  }

  @Action(SetFailureOverlay)
  setFailureOverlay(
    ctx: StateContext<UIStateModel>,
    action: SetFailureOverlay
  ) {
    ctx.patchState({
      showFailureOverlay: true,
      message: action.payload,
    });
  }

  @Action(SetNotificationOverlay)
  setErrorOverlay(
    ctx: StateContext<UIStateModel>,
    action: SetNotificationOverlay
  ) {
    ctx.patchState({
      showNotificationOverlay: true,
      notificationType: action.payload.type,
      message: action.payload.message,
    });
  }

  @Action(SetLanguage)
  setLanguage(ctx: StateContext<UIStateModel>, action: SetLanguage) {
    ctx.patchState({
      language: action.payload,
    });
  }

  @Action(SelectPlace)
  selectPlace(ctx: StateContext<UIStateModel>, action: SelectPlace) {
    ctx.patchState({
      selectedPlace: action.payload,
    });
  }

  @Action(SelectBranch)
  selectBranch(ctx: StateContext<UIStateModel>, action: SelectBranch) {
    ctx.patchState({
      selectedBranch: action.payload,
    });
  }

  @Action(SetItemScrolledToBottom)
  setItemScrolledToEnd(
    ctx: StateContext<UIStateModel>,
    action: SetItemScrolledToBottom
  ) {
    ctx.patchState({
      itemsScrolledToBottom: action.payload,
    });
  }

  @Action(CompanyInfoLoaded)
  setCompanyInfoLoaded(ctx: StateContext<UIStateModel>, action: any) {
    ctx.patchState({
      companyInfoLoaded: action.payload,
    });
  }
}
